import { BlockType, StepData } from '@shared/models/step.model';
import { EntityStatus } from '@shared/models/menu.model';

export const getMockStepDataBlockerStep = (): StepData => {
  return {
    id: 121,
    title: 'Level 1 Complete',
    name: 'Level 1 Complete',
    description: '10000 minutes',
    congrats: '<p>Well done, your progress has been saved. Continue to your next step below.</p>',
    hideStepInMenu: false,
    breadcrumbs: 'Level 3 &bull; Module &bull; Level 1 Complete',
    prev_page_url: null,
    next_page_url: null,
    fullUrl: '/c/c/m/page-unavailable',
    slug: 'page-unavailable',
    status: EntityStatus.current,
    blocks: [
      {
        id: 334,
        element: BlockType.html,
        source_program_data_code: null,
        program_data_code: null,
        data: {
          value:
            '<h2>Level 1 complete</h2>\r\n<p>Congratulations, you have completed the Potentialife Level 1 leadership development program. </p>\r\n<p>To find out about further development offered by Potentialife, please get in touch with us at <a href="mailto:support@potentialife.com">support@potentialife.com</a> </p>',
        },
      },
    ],
  };
};
